import { gql } from '@apollo/client'

export const ATUALIZAR_GRUPO_FAVORITO = gql`
  mutation AtualizarGrupoFavorito($id: ID!) {
    atualizarGrupoFavorito(id: $id) {
      id
      nome
      favorito
    }
  }
`
